import * as React from 'react';

import { DropdownFilter, MaterialsDropdown } from '../../../../components/Filters';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TThunkDispatch } from '../../../../types/redux';
import { changeSavedFilters } from '../../../../actions/filters';
import { useDropdownFilter } from '../../hooks/useDropdownFilter';
import { selectMaterialsFilter } from '../../../../selectors/filters/selectMaterialsFilter';
import { EMaterials } from '../../../../types/buildersProjects';
import { useEventCallback } from '@cian/react-utils';
import { getMaterialsLabel } from './utils/getMaterialsLabel';
import { sortListValue } from '../../utils/sortListValues';

const SORTED_MATERIALS = [
  EMaterials.Blocks,
  EMaterials.Brick,
  EMaterials.GluedLaminatedTimber,
  EMaterials.SolidTree,
  EMaterials.FrameHouses,
  EMaterials.Monolith,
  EMaterials.Sip,
  EMaterials.Other,
];

export const MaterialsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();

  const materials = useSelector(selectMaterialsFilter, shallowEqual);

  const { filterRef, tooltipOpened, isOpen, onClick, onClose } = useDropdownFilter('materials');

  const handleMaterialsChange = useEventCallback((value: EMaterials[]) => {
    const newMaterials = sortListValue(value, SORTED_MATERIALS);

    dispatch(changeSavedFilters({ materials: newMaterials }, 'materials'));
  });

  const label = React.useMemo(() => getMaterialsLabel(materials) || 'Материал', [materials]);

  return (
    <div ref={filterRef}>
      <DropdownFilter
        open={isOpen}
        label={label}
        openTooltip={tooltipOpened}
        onClose={onClose}
        onClick={onClick}
        dataName="Materials"
        count={materials.length}
        dropdownContent={
          <MaterialsDropdown
            materials={materials}
            onChange={handleMaterialsChange}
            tooltipOpened={tooltipOpened}
            filterRef={filterRef}
            onClose={onClose}
          />
        }
      />
    </div>
  );
};
